/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC721, ERC721Interface } from "../ERC721";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC721ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721__factory extends ContractFactory {
  constructor(...args: ERC721ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ERC721";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721> {
    return super.deploy(overrides || {}) as Promise<ERC721>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ERC721 {
    return super.attach(address) as ERC721;
  }
  connect(signer: Signer): ERC721__factory {
    return super.connect(signer) as ERC721__factory;
  }
  static readonly contractName: "ERC721";
  public readonly contractName: "ERC721";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721Interface {
    return new utils.Interface(_abi) as ERC721Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ERC721 {
    return new Contract(address, _abi, signerOrProvider) as ERC721;
  }
}
